import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';

export const promocodeInMenuMobile = isFeature('promocode-in-menu');
export const promocodeInTabsEnabled = isFeature('promocode-in-tabs');

const promocodeInFooterDesktop = isFeature('promocode-in-footer');
const promocodeInFooterMobile = isFeature('promocode-in-footer-mobile');
export const promocodeInFooterEnabled = IS_MOBILE_BROWSER ? promocodeInFooterMobile : promocodeInFooterDesktop;

export const promocodeInOptions = isFeature('promocode-in-options');
export const promocodeInTariffsMobile = isFeature('promocode-in-tariffs');

const promocodeModalFromQueryActionDesktop = isFeature('promocode-query-action');
const promocodeModalFromQueryActionMobile = isFeature('promocode-query-action-mobile');

export const promocodeModalFromQueryAction = IS_MOBILE_BROWSER ? promocodeModalFromQueryActionMobile : promocodeModalFromQueryActionDesktop;

export const promocodeInActionMobile = isFeature('promocode-in-action-mobile');
